import api from '../../services/faq';
export default function (helper) {

  /**
   * Generated store module
   */
  helper.setApi(api);
  const types = helper.types('faq');
  const state = helper.state();
  const getters = helper.getters();
  const actions = helper.actions({}, 'FAQ');
  const mutations = helper.mutations({}, types, state);

  return {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };
}